// WS-4 (OP-227) i18n — "analytics" cluster: the Analytics dashboard
// (src/pages/analytics/AnalyticsDashboardPage.tsx). Spread into the central
// LABELS in labels.ts. EN values MUST equal the screen's current hardcoded
// English so existing text-based tests stay green; HE values are the Hebrew
// translation.
export const ANALYTICS_LABELS = {
  analyticsLoading: { en: 'Loading analytics...', he: 'טוען אנליטיקה...' },
  analyticsLoadError: { en: 'Failed to load analytics data.', he: 'טעינת נתוני האנליטיקה נכשלה.' },
  analyticsTitle: { en: 'Analytics', he: 'אנליטיקה' },
  analyticsTabOverview: { en: 'Overview', he: 'סקירה' },
  analyticsTabQuestions: { en: 'Questions', he: 'שאלות' },
  analyticsTabConsultations: { en: 'Consultations', he: 'התייעצויות' },
  analyticsTabCost: { en: 'Cost', he: 'עלות' },
  analyticsFrom: { en: 'From', he: 'מתאריך' },
  analyticsTo: { en: 'To (inclusive)', he: 'עד תאריך (כולל)' },
  analyticsChannel: { en: 'Channel', he: 'ערוץ' },
  analyticsAllChannels: { en: 'All channels', he: 'כל הערוצים' },
  analyticsChannelNotApplied: { en: 'The channel filter does not apply to this tab.', he: 'מסנן הערוץ אינו חל על לשונית זו.' },
  analyticsConversations: { en: 'Conversations', he: 'שיחות' },
  analyticsBotOnly: { en: 'Resolved by the bot alone', he: 'נפתרו על ידי הבוט לבד' },
  analyticsTimeToAnswer: { en: 'Time to answer (median / p90)', he: 'זמן עד תשובה (חציון / p90)' },
  analyticsConsultationRate: { en: 'Turns that needed a teammate', he: 'פניות שנזקקו לחבר צוות' },
  analyticsClarifyingRate: { en: 'Clarifying questions', he: 'שאלות הבהרה' },
  analyticsOutOfScopeRate: { en: 'Out of scope', he: 'מחוץ לתחום' },
  analyticsFactualityDiscard: { en: 'Drafts discarded by the fact check', he: 'טיוטות שנפסלו בבדיקת עובדות' },
  analyticsAvgCertainty: { en: 'Average certainty', he: 'ודאות ממוצעת' },
  analyticsTurnsPerDay: { en: 'Bot turns per day', he: 'פניות לבוט ביום' },
  analyticsTurnsByHour: { en: 'Bot turns by hour of day', he: 'פניות לבוט לפי שעה ביום' },
  analyticsReason: { en: 'Reason', he: 'סיבה' },
  analyticsAllReasons: { en: 'All reasons', he: 'כל הסיבות' },
  analyticsQuestionText: { en: 'Question', he: 'שאלה' },
  analyticsAskedAt: { en: 'Asked', he: 'נשאלה' },
  analyticsSession: { en: 'Conversation', he: 'שיחה' },
  analyticsNoQuestions: { en: 'No unanswered questions in this period.', he: 'אין שאלות שלא נענו בתקופה זו.' },
  analyticsQuestionsRetention: { en: 'Question text is kept for 90 days.', he: 'נוסח השאלות נשמר 90 יום.' },
  analyticsReasonNoKnowledge: { en: 'No knowledge', he: 'אין ידע' },
  analyticsReasonLowCertainty: { en: 'Low certainty', he: 'ודאות נמוכה' },
  analyticsReasonBotNeedsHuman: { en: 'Needed a person to act', he: 'נדרש אדם לפעולה' },
  analyticsReasonOutOfScope: { en: 'Out of scope', he: 'מחוץ לתחום' },
  analyticsReasonCustomerKeyword: { en: 'Asked for a person', he: 'ביקש נציג' },
  analyticsReasonClarifyingLimit: { en: 'Too many clarifying questions', he: 'יותר מדי שאלות הבהרה' },
  analyticsConsultCount: { en: 'Consultations', he: 'התייעצויות' },
  analyticsConsultResponse: { en: 'Teammate response (median / p90)', he: 'זמן תגובת חבר צוות (חציון / p90)' },
  analyticsConsultTimeout: { en: 'Timed out unanswered', he: 'פג זמן ללא מענה' },
  analyticsConsultDismissedByCustomer: { en: 'Withdrawn by the customer', he: 'בוטלו על ידי הלקוח' },
  analyticsAllTenants: { en: 'All tenants', he: 'כל הדיירים' },
  analyticsCostPerConversation: { en: 'Per conversation', he: 'לשיחה' },
  analyticsCostPerBotOnly: { en: 'Per bot-resolved conversation', he: 'לשיחה שנפתרה על ידי הבוט' },
  analyticsCostPerBotOnlyInCategory: { en: 'Per bot-resolved conversation (in this category)', he: 'לשיחה שנפתרה על ידי הבוט (בקטגוריה זו)' },
  analyticsUnattributed: { en: 'Unattributed tokens', he: 'טוקנים ללא שיוך' },
  analyticsNoPrice: { en: 'no price set', he: 'לא הוגדר מחיר' },
  analyticsPartialPricing: {
    en: 'Totals and per-conversation figures cover priced models only. No price is set for:',
    he: 'הסכומים והנתונים לשיחה כוללים רק מודלים עם מחיר. לא הוגדר מחיר עבור:',
  },
  analyticsTokens: { en: 'Tokens (in / cached / out)', he: 'טוקנים (קלט / מטמון / פלט)' },
  analyticsPrices: { en: 'Model prices (USD per 1M tokens)', he: 'מחירי מודלים (דולר למיליון טוקנים)' },
  analyticsModel: { en: 'Model', he: 'מודל' },
  analyticsModelHint: {
    en: 'Use the Azure deployment name exactly as configured (e.g. the value of AiAgent.LLM.Model) — usage is recorded per deployment.',
    he: 'יש להזין את שם הפריסה ב-Azure בדיוק כפי שהוגדר (למשל הערך של AiAgent.LLM.Model) — השימוש נרשם לפי פריסה.',
  },
  analyticsEffectiveFrom: { en: 'Effective from', he: 'בתוקף מ-' },
  analyticsInputPrice: { en: 'Input', he: 'קלט' },
  analyticsCachedPrice: { en: 'Cached input', he: 'קלט מהמטמון' },
  analyticsOutputPrice: { en: 'Output', he: 'פלט' },
  analyticsSavePrice: { en: 'Save price', he: 'שמור מחיר' },
  analyticsDeletePrice: { en: 'Delete', he: 'מחק' },
  analyticsPriceForbidden: { en: 'Only a platform administrator can change prices.', he: 'רק מנהל פלטפורמה יכול לשנות מחירים.' },
  analyticsPriceError: { en: 'Could not save the price change.', he: 'שמירת שינוי המחיר נכשלה.' },
  analyticsSelectTenant: { en: 'Select a tenant to see its analytics.', he: 'בחרו ארגון כדי לראות את האנליטיקה שלו.' },
  analyticsConfirmDelete: { en: 'Confirm delete', he: 'אשר מחיקה' },
  analyticsCancel: { en: 'Cancel', he: 'ביטול' },
  analyticsConfirmDeletePrompt: { en: 'Delete this price?', he: 'למחוק את המחיר הזה?' },
  analyticsValidationModel: { en: 'Model is required (up to 100 characters).', he: 'יש להזין מודל (עד 100 תווים).' },
  analyticsValidationPrice: { en: 'Prices must be numbers of 0 or more.', he: 'המחירים חייבים להיות מספרים מ-0 ומעלה.' },
  analyticsValidationDate: { en: 'Effective-from date is required.', he: 'יש להזין תאריך תחילת תוקף.' },
  analyticsCost: { en: 'Cost', he: 'עלות' },
  analyticsGranularity: { en: 'Period', he: 'תקופה' },
  analyticsDay: { en: 'Day', he: 'יום' },
  analyticsWeek: { en: 'Week', he: 'שבוע' },
  analyticsMonth: { en: 'Month', he: 'חודש' },
  analyticsGraphBy: { en: 'Graph by', he: 'גרף לפי' },
  analyticsGraphCategory: { en: 'Category', he: 'קטגוריה' },
  analyticsGraphTenant: { en: 'Tenant', he: 'דייר' },
  analyticsGraphModel: { en: 'Model', he: 'מודל' },
  analyticsTotalPaid: { en: 'Total paid (USD)', he: 'סך ששולם (דולר)' },
  analyticsTokensKpi: { en: 'Tokens', he: 'טוקנים' },
  analyticsImagesOcr: { en: 'Images (OCR)', he: 'תמונות (OCR)' },
  analyticsImages: { en: 'Images', he: 'תמונות' },
  analyticsCostPerConversationInCategory: { en: 'Per conversation (in this category)', he: 'לשיחה (בקטגוריה זו)' },
  analyticsWeekOf: { en: 'Week of', he: 'שבוע של' },
  analyticsBucketTotal: { en: 'Total', he: 'סה"כ' },
  analyticsChartTitle: { en: 'Cost over time (USD)', he: 'עלות לאורך זמן (דולר)' },
  analyticsChartEmpty: { en: 'No cost recorded in this period.', he: 'לא נרשמה עלות בתקופה זו.' },
  analyticsTableByCategory: { en: 'Cost by category', he: 'עלות לפי קטגוריה' },
  analyticsTableByTenant: { en: 'Cost by tenant', he: 'עלות לפי דייר' },
  analyticsTableByModel: { en: 'Cost by model', he: 'עלות לפי מודל' },
  analyticsColCategory: { en: 'Category', he: 'קטגוריה' },
  analyticsColTenant: { en: 'Tenant', he: 'דייר' },
  analyticsTotalRow: { en: 'Total', he: 'סה"כ' },
  analyticsSumAllTenants: { en: 'Sum of all tenants', he: 'סכום כל הדיירים' },
  analyticsExpandCategory: { en: 'Show steps', he: 'הצג שלבים' },
  analyticsCollapseCategory: { en: 'Hide steps', he: 'הסתר שלבים' },
  analyticsPerThousandImages: { en: 'Per 1,000 images (USD)', he: 'ל-1,000 תמונות (דולר)' },
  analyticsOcrHint: { en: 'Azure AI Vision Read (OCR): priced per 1,000 images', he: 'Azure AI Vision Read (OCR): התמחור לפי 1,000 תמונות' },
  analyticsPriceCol1000Images: { en: 'Per 1,000 images', he: 'ל-1,000 תמונות' },
  analyticsCat_chat_answers: { en: 'Customer chat answers', he: 'תשובות לשיחות לקוחות' },
  analyticsCat_consultations: { en: 'Consultations', he: 'התייעצויות' },
  analyticsCat_acks_editing: { en: 'Acknowledgements & reply editing', he: 'אישורי קבלה ועריכת תשובות' },
  analyticsCat_images: { en: 'Images', he: 'תמונות' },
  analyticsCat_kb_building: { en: 'Knowledge base building', he: 'בניית מאגר ידע' },
  analyticsCat_kb_search_embeddings: { en: 'Knowledge search & embeddings', he: 'חיפוש ידע והטמעות' },
  analyticsCat_learning: { en: 'Learning', he: 'למידה' },
  analyticsCat_memory: { en: 'Memory', he: 'זיכרון' },
  analyticsCat_email_drafts: { en: 'Email drafts', he: 'טיוטות מייל' },
  analyticsCat_other: { en: 'Other', he: 'אחר' },
} satisfies Record<string, { en: string; he: string }>;
